var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5251_10424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7829 12.8667C13.2984 12.8667 13.7163 12.4488 13.7163 11.9333C13.7163 11.4179 13.2984 11 12.7829 11C12.2675 11 11.8496 11.4179 11.8496 11.9333C11.8496 12.4488 12.2675 12.8667 12.7829 12.8667Z",
    fill: "#99D7D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8169 13.4004C12.2085 13.4004 10.9919 13.7004 10.9502 14.3004C11.3669 14.8921 12.0502 15.2754 12.8169 15.2754C13.5835 15.2754 14.2669 14.8921 14.6835 14.3004C14.6419 13.7004 13.4252 13.4004 12.8169 13.4004Z",
    fill: "#99D7D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 8.663V5.289L8.25 3L3 5.289V8.726C3 11.904 5.24 14.879 8.25 15.6C8.635 15.509 9.006 15.376 9.37 15.215C10.126 16.293 11.379 17 12.8 17C15.117 17 17 15.117 17 12.8C17 10.721 15.488 8.999 13.5 8.663ZM8.6 12.8C8.6 13.192 8.656 13.577 8.761 13.934C8.593 14.011 8.425 14.088 8.25 14.144C6.031 13.444 4.4 11.176 4.4 8.726V6.206L8.25 4.526L12.1 6.206V8.663C10.112 8.999 8.6 10.721 8.6 12.8ZM12.8 15.6C11.253 15.6 10 14.347 10 12.8C10 11.253 11.253 10 12.8 10C14.347 10 15.6 11.253 15.6 12.8C15.6 14.347 14.347 15.6 12.8 15.6Z",
    fill: "#99D7D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5251_10424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin1);
export default __webpack_public_path__ + "static/media/admin1.65340021995329f1bef46a01e34345ef.svg";
export { ForwardRef as ReactComponent };